function normalizeAgeRatingId(value) {
  let rawId = value && typeof value === 'object' ? value.id : value;

  if (typeof rawId === 'string') rawId = rawId.trim();

  if (rawId === null || rawId === undefined || rawId === '') return null;

  const numericId = Number(rawId);
  return Number.isFinite(numericId) ? numericId : rawId;
}

function parseIds(value) {
  if (typeof value !== 'string') return value;

  const trimmedValue = value.trim();
  if (!trimmedValue.startsWith('[')) return value;

  try {
    return JSON.parse(trimmedValue);
  } catch {
    return value;
  }
}

export function normalizeAgeRatingIds(value) {
  const parsedValue = parseIds(value);
  const values = Array.isArray(parsedValue) ? parsedValue : [parsedValue];

  return [...new Set(values.map(normalizeAgeRatingId).filter(id => id !== null))];
}

export function getProjectAgeRatingIds(project = {}) {
  if (!project || typeof project !== 'object') return [];

  if (
    Object.prototype.hasOwnProperty.call(project, 'age_rating_ids')
    && project.age_rating_ids !== null
    && project.age_rating_ids !== undefined
  ) {
    return normalizeAgeRatingIds(project.age_rating_ids);
  }

  if (
    Object.prototype.hasOwnProperty.call(project, 'age_ratings')
    && project.age_ratings !== null
    && project.age_ratings !== undefined
  ) {
    return normalizeAgeRatingIds(project.age_ratings);
  }

  return normalizeAgeRatingIds(project.age_rating_id ?? project.age_rating?.id ?? null);
}

export function getHighestAgeRating(ageRatings = [], selectedIds = [], fallback = null) {
  const normalizedIds = new Set(normalizeAgeRatingIds(selectedIds));
  const selectedRatings = ageRatings.filter(rating => (
    normalizedIds.has(normalizeAgeRatingId(rating?.id))
  ));

  if (!selectedRatings.length) return fallback;

  return selectedRatings.reduce((highest, rating) => {
    if (!highest) return rating;

    const highestAge = Number(highest.age) || 0;
    const ratingAge = Number(rating.age) || 0;
    if (ratingAge !== highestAge) return ratingAge > highestAge ? rating : highest;

    const highestId = normalizeAgeRatingId(highest.id);
    const ratingId = normalizeAgeRatingId(rating.id);
    return ratingId < highestId ? rating : highest;
  }, null);
}
